<template>
  <div
    id=app
    class="page-container"
  >
    <div
      id="container"
      class="container md-layout-column"
      v-if="user!=null"
    >
      <md-toolbar class="md-warn">
        <md-button
          class="md-icon-button"
          @click="goHome"
        >
          <md-icon class="
          md-size-2x">build_circle</md-icon>
        </md-button>
        <span class="md-title"><b>BeProduct Automation</b></span>

        <div class="md-toolbar-section-end">
          <div>
            <md-button class="md-plain username"> {{user.FullName}}</md-button>
            <md-avatar>
              <img
                :src="avatarUrl"
                alt="Profile Image"
              >
            </md-avatar>
            <md-button
              class="md-icon-button"
              @click="signOut"
            >
              <md-icon>logout</md-icon>
            </md-button>
          </div>
        </div>
      </md-toolbar>

      <md-content id="content">
        <router-view> </router-view>
      </md-content>
    </div>

    <md-toolbar v-else>
      <h3 class="md-title">Authorizing. Stand by...</h3>
    </md-toolbar>

    <md-bottom-bar md-sync-route>
    </md-bottom-bar>
  </div>
</template>

<script>
import Vue from "vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default-dark.css";
import auth from "./auth";

Vue.use(VueMaterial);

export default {
  name: "App",
  data: () => ({
    user: null,
    IMAGE_SERVER_URL: process.env.VUE_APP_IMAGE_SERVER,
    avatarUrl: null,
  }),
  async mounted() {
    this.user = JSON.parse((await auth.manager.getUser()).profile.userinfo);
    this.avatarUrl =
      this.IMAGE_SERVER_URL + `profile/${this.user.Id}.jpg?width=75`;
  },
  methods: {
    signOut() {
      auth.signOut();
    },
    goHome() {
      window.location = "/";
    },
  },
};
</script>
<style>
body {
  height: 100%;
}

.page-container {
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(#000, 0.12);
}

.md-content {
  padding: 16px;
}

.username {
  pointer-events: none;
}

.md-table-cell-container {
  padding: 5px !important;
}
.md-datepicker > .md-icon:after {
  background-color: transparent !important;
}
</style>
